(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["abonelik-onay-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay  = document.getElementById('agr-modal');
    if (!overlay) return;
    var checkbox  = document.getElementById('agr-modal-checkbox');
    var acceptBtn = document.getElementById('agr-modal-accept');
    var body      = document.getElementById('agr-modal-body');
    var onAccept  = null;

    function close() {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      onAccept = null;
    }

    checkbox.addEventListener('change', function () {
      acceptBtn.disabled = !checkbox.checked;
    });
    acceptBtn.addEventListener('click', function () {
      if (!checkbox.checked || !onAccept) return;
      var cb = onAccept;
      close();
      cb(new Date().toISOString());
    });
    document.getElementById('agr-modal-close').addEventListener('click', close);
    document.getElementById('agr-modal-cancel').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    window.tkahveAgreementConfirm = function (cb) {
      onAccept = cb;
      checkbox.checked = false;
      acceptBtn.disabled = true;
      body.scrollTop = 0;
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cerez-bandi"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'tkahve_cookie_consent';
    var bar = document.getElementById('cookie-bar');
    if (!bar) return;

    function readChoice() {
      try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
    }

    // Tercihi Shopify Customer Privacy API'sine bildir: "reddet" diyen
    // ziyaretçi için Shopify'ın analitik/pazarlama izlemesi gerçekten kapanır.
    function applyToShopify(accepted) {
      try {
        if (!window.Shopify || !window.Shopify.loadFeatures) return;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err || !window.Shopify.customerPrivacy) return;
          try {
            window.Shopify.customerPrivacy.setTrackingConsent(
              { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: false },
              function () {}
            );
          } catch (e) {}
        });
      } catch (e) {}
    }

    function choose(accepted) {
      try { localStorage.setItem(KEY, JSON.stringify({ v: 1, accepted: accepted, at: new Date().toISOString() })); } catch (e) {}
      applyToShopify(accepted);
      bar.classList.remove('is-visible');
    }

    var saved = readChoice();
    if (saved && typeof saved.accepted === 'boolean') {
      // Kayıtlı tercihi her yüklemede yeniden uygula (Shopify tarafı kalıcı değil)
      applyToShopify(saved.accepted);
      return;
    }

    document.getElementById('cookie-accept').addEventListener('click', function () { choose(true); });
    document.getElementById('cookie-reject').addEventListener('click', function () { choose(false); });
    bar.classList.add('is-visible');
  })();
  } catch(e) { console.error(e); }
})();

})();
